/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na bazény recyklovaných objektů.
 */
class PoolFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<Pool>} Pool
   */
  constructor(Pool) {
    this.Pool = Pool;
  }

  /**
   * Vytvoří nový bazén.
   * @param {PoolObjectFactory} factory Továrna pro vytváření nových objektů umísťených v bazénu.
   * @param {Object} [opts={}] Nepovinné parametry.
   * @param {number} [opts.max=Infinity] Maximální počet objektů, které má bazén vytvořit.
   * @returns {Pool}
   */
  create(factory, { max = Infinity } = {}) {
    return new this.Pool(factory, max);
  }
}

export default PoolFactory;
